import { authorizedApi } from './index';

export const withdrawalApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    startWithdrawal: builder.mutation({
      query: (params) => ({
        url: '/withdrawal/start',
        method: 'POST',
        body: { network: 'solana', ...params },
      }),
    }),

    getWithdrawalInfo: builder.query({
      query: (uuid) => ({
        url: `/withdrawal/${uuid}`,
        method: 'GET',
      }),
    }),

    getWithdrawalHistory: builder.query({
      query: () => ({
        url: '/withdrawal',
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useStartWithdrawalMutation,
  useGetWithdrawalInfoQuery,
  useGetWithdrawalHistoryQuery,
} = withdrawalApi;
